import { TokenDetails } from './models/auth/token-details.type';
import { AuthenticationService } from './services/api/authentication/authentication.service';
import { TokenService } from './services/api/authentication/token.service';
import { AuthActions } from './store/actions/auth.actions';
import { TemplateLoaderService } from './services/template-loader/template-loader.service';
import { AppState } from './store/state/app.state';

import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

// https://medium.com/@gmurop/managing-dependencies-among-app-initializers-in-angular-652be4afce6f
// https://www.intertech.com/Blog/angular-4-tutorial-run-code-during-app-initialization/

export function authInitializer(
  authService: AuthenticationService,
  store: Store<AppState>,
  templateLoaderService: TemplateLoaderService,
  tokenService: TokenService
): () => Promise<any> {
  return (): Promise<any> =>
    initB2C(authService, store, templateLoaderService, tokenService);
}

function initB2C(
  authService: AuthenticationService,
  store: Store<AppState>,
  templateLoaderService: TemplateLoaderService,
  tokenService: TokenService
): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      store.dispatch(AuthActions.Login());
      setTokenDetails(authService, store, tokenService);
      // Load the runtime template config
      templateLoaderService.loadRuntimeTemplateConfig();

      return resolve(true);
    } catch (error) {
      console.error('Error during initialization:', error);

      return reject(error);
    }
  });
}

function setTokenDetails(
  authService: AuthenticationService,
  store: Store<AppState>,
  tokenService: TokenService
): void {
  authService.token
    .pipe(filter((token: string | undefined): token is string => !!token))
    .subscribe((token) => {
      const uniqueId = tokenService.getUniqueId(token);
      const tokenDetails = tokenService.decodeToken(token);
      store.dispatch(
        AuthActions.setTokenDetails({
          tokenDetails: {
            idToken: token,
            uniqueId,
            idTokenClaims: tokenDetails,
          } as TokenDetails,
        })
      );
    });
}
